import { createRouter, createWebHashHistory } from 'vue-router'
import store from './store/index.js'
import App from './App.vue'
import FacilityProfile from './components/workspace/input-panels/FacilityProfile.vue'
import CustomFacilityProfile from './components/workspace/input-panels/CustomFacilityProfile.vue'
import GetPricing from './components/workspace/input-panels/GetPricing.vue'
import StartMonth from './components/workspace/input-panels/StartMonth.vue'
import TermLength from './components/workspace/input-panels/TermLength.vue'
import PricingData from './components/workspace/output/PricingData.vue'
import PricingTable from './components/dashboard/PricingTable.vue'
import Utility from './components/workspace/input-panels/Utility.vue'
import Volume from './components/workspace/input-panels/Volume.vue'
import moment from 'moment'

export default createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      component: App,
      children: [
        {
          path: '/i/:uuid',
          component: Utility,
          beforeEnter: (to, from, next) => {

            // Prevent access when inactive price request is loaded.
            if (store.getters.startMonth) {
              if (moment(store.getters.startMonth).isBefore()) {
                return
              }
            }

            if (store.getters.view != 'workspace') {
              store.dispatch('setStoreView', 'workspace') 
            }

            next()
          }
        },
        {
          path: '/',
          component: Utility,
          beforeEnter: (to, from, next) => {

            // Prevent access when inactive price request is loaded.
            if (store.getters.startMonth) {
              if (moment(store.getters.startMonth).isBefore()) {
                return
              }
            }

            if (store.getters.view != 'workspace') {
              store.dispatch('setStoreView', 'workspace') 
            }

            next()
          }
        },
        {
          path: 'utility',
          component: Utility,
          name: 'Utility',
          beforeEnter: (to, from, next) => {

            // Prevent access when inactive price request is loaded.
            if (store.getters.startMonth) {
              if (moment(store.getters.startMonth).isBefore()) {
                return
              }
            }

            if (store.getters.view != 'workspace') {
              store.dispatch('setStoreView', 'workspace') 
            }

            next()
          }
        },
        {
          path: 'start-month',
          component: StartMonth,
          name: 'StartMonth',
          beforeEnter: (to, from, next) => {

            // Prevent access when inactive price request is loaded.
            if (store.getters.startMonth) {
              if (moment(store.getters.startMonth).isBefore()) {
                return
              }
            }

            if (store.getters.view != 'workspace') {
              store.dispatch('setStoreView', 'workspace') 
            }

            if (store.getters.currentPricingRequest.utilityMeta.name && store.getters.currentPricingRequest.utilityMeta.code){
              next()
            } else {
              next({ name: 'Utility' })
            }
          }
        },
        {
          path: 'term-length',
          component: TermLength,
          name: 'TermLength',
          beforeEnter: (to, from, next) => {

            if (store.getters.view != 'workspace') {
              store.dispatch('setStoreView', 'workspace') 
            }

            if (store.getters.startMonth){
              if (moment(store.getters.startMonth).isBefore()) {
                return
              }

              next()
            } else {
              next({ name: 'StartMonth' })
            }
          }
        },
        {
          path: 'facility-profile',
          component: FacilityProfile,
          name: 'FacilityProfile',
          beforeEnter: (to, from, next) => {

            // Prevent access when inactive price request is loaded.
            if (store.getters.startMonth) {
              if (moment(store.getters.startMonth).isBefore()) {
                return
              }
            }

            if (store.getters.view != 'workspace') {
              store.dispatch('setStoreView', 'workspace') 
            }

            let terms = store.getters.termLength
            terms = terms.filter(function(item) {
              return item.value != ''
            })
            if (Object.keys(terms).length > 0){
              next()
            } else {
              next({ name: 'TermLength' })
            }
          }
        },
        {
          path: 'custom-facility-profile',
          component: CustomFacilityProfile,
          name: 'CustomFacilityProfile',
          beforeEnter: (to, from, next) => {

            // Prevent access when inactive price request is loaded.
            if (store.getters.startMonth) {
              if (moment(store.getters.startMonth).isBefore()) {
                return
              }
            }

            if (store.getters.view != 'workspace') {
              store.dispatch('setStoreView', 'workspace') 
            }

            let terms = store.getters.termLength
            terms = terms.filter(function(item) {
              return item.value != ''
            })

            if (Object.keys(terms).length > 0){
              next()
            } else {
              next({ name: 'TermLength' })
            }
          }
        },
        {
          path: 'volume',
          component: Volume,
          name: 'Volume',
          beforeEnter: (to, from, next) => {

            // Prevent access when inactive price request is loaded.
            if (store.getters.startMonth) {
              if (moment(store.getters.startMonth).isBefore()) {
                return
              }
            }

            if (store.getters.view != 'workspace') {
              store.dispatch('setStoreView', 'workspace') 
            }

            let terms = store.getters.termLength
            terms = terms.filter(function(item) {
              return item.value != ''
            })

            if (store.getters.startMonth && Object.keys(terms).length > 0 && store.getters.startMonth && store.getters.facilityType.name && store.getters.customFacilityProfileComplete) {
              next()
            } else {
              next({ name: 'FacilityProfile' })
            }
          }
        },
        {
          path: 'get-pricing',
          component: GetPricing,
          name: 'GetPricing',
          beforeEnter: (to, from, next) => {

            // Prevent access when inactive price request is loaded.
            if (store.getters.startMonth) {
              if (moment(store.getters.startMonth).isBefore()) {
                return
              }
            }

            if (store.getters.view != 'workspace') {
              store.dispatch('setStoreView', 'workspace') 
            }

            if (!store.getters.customFacilityProfileComplete) {
              next({ name: 'Volume' })
            }

            // If a broker fee has not been entered, and we're not declining to enter one...
            if (!store.getters.pricingRequestVolume.brokerFee && !store.getters.declineBrokerFee) {

              if (store.getters.customFacilityVolume.brokerFee) {
                next()
              } else {
                next({ name: 'Volume' })
              }

            // ...otherwise, if... ¯\_(ツ)_/¯
            } else if (store.getters.pricingRequestVolume.amount || store.getters.customFacilityVolume.declineBrokerFee) {
              next()

            } else {
              if (from.name == 'Volume') {
                next()
              } else {
                next({ name: 'Volume' })
              }
            }
          }
        },
        {
          path: 'pricing-data',
          component: PricingData,
          name: 'PricingData',
          beforeEnter: (to, from, next) => {

            if (store.getters.view != 'workspace') {
              store.dispatch('setStoreView', 'workspace') 
            }

            if (store.getters.pricingRequestStatus){
              next()
            } else {
              next({ name: 'Utility' })
            }
          }
        },
        {
          path: '/dashboard',
          component: PricingTable,
          name: 'PricingTable',
          beforeEnter: (to, from, next) => {

            function setDashboardView(store) {
              if (store.getters.view != 'dashboard') {
                store.dispatch('setStoreView', 'dashboard') 
              }
            }

            if (
              store.getters.planConfig.priceRequestSlots && 
              store.getters.planConfig.priceRequestSlots > 0
            ) {
              // Check access.
              const productAccess = store.getters.userProductAccess
              if (! productAccess['apm']) {
                next({ name: 'Utility' })

              } else {
                setDashboardView(store);
                next()
              }

            } else if (!store.getters.planConfig.priceRequestSlots) {

              axios.get('/pricing-calculator/me')
                .then(response => {
                  if (
                    response.data.plan && 
                    response.data.plan.slug != 'free' &&
                    response.data.user.productAccess['apm'] // Check access.
                  ) {
                    setDashboardView(store);
                    next()
                  } else {
                    next({ name: 'Utility' })
                  }
                })
                .catch(error => {
                  next({ name: 'Utility' })
                })

            } else {
              next({ name: 'Utility' })
            }
          }
        }
      ]
    }
  ]
})
